import { render, staticRenderFns } from "./TheLanguageSwitcher.vue?vue&type=template&id=3c3558a1"
import script from "./TheLanguageSwitcher.vue?vue&type=script&lang=js"
export * from "./TheLanguageSwitcher.vue?vue&type=script&lang=js"
import style0 from "./TheLanguageSwitcher.vue?vue&type=style&index=0&id=3c3558a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports